const memberKey = {
    mid: true,
    token: true,
    nickname: true,
    expire_ts_sehseh: true,
    login_time: true,
    avatar: true
};

const setMemberData = (data) => {
    Object.keys(data).forEach(key => {
        if (memberKey[key]) sessionStorage.setItem(key, data[key]);
    });
};

const eventGetSessionStorageData = (event) => {
    window.localStorage.setItem('sessionStorageData', JSON.stringify(window.sessionStorage));
    window.localStorage.removeItem('sessionStorageData');
};

const eventSessionStorageData = (event) => {
    setMemberData(JSON.parse(event.newValue));
};

const eventLogin = (event) => {
    window.localStorage.removeItem('login');
    setMemberData(JSON.parse(event.newValue));
    window.location.reload();
};

const eventLogout = (event) => {
    window.localStorage.removeItem('logout');
    window.sessionStorage.clear();
    window.location.reload();
};

window.sehsehLogout = () => {
    if ((!!sessionStorage.getItem("mid")) && (!!sessionStorage.getItem("token"))) {
        sessionStorage.clear();
        localStorage.setItem("logout", Date.now());
    }
}

(() => {
    if (!window.sessionStorage.length) {
        window.localStorage.setItem('getSessionStorageData', Date.now())
    }

    window.addEventListener('storage', (event) => {
        //console.log(event.key, event);
        if (event.key === 'getSessionStorageData') eventGetSessionStorageData(event);
        if (event.key === 'sessionStorageData' && !window.sessionStorage.length && event.newValue) eventSessionStorageData(event);
        if (event.key === 'login' && event.newValue) eventLogin(event);
        if (event.key === 'logout' && event.newValue) eventLogout(event);
    })
})();